import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import type { AsyncHasMany, AsyncBelongsTo } from '@ember-data/model';
import type CompanyModel from 'garaje/models/company';
import type LocationModel from 'garaje/models/location';
import type WorkplaceDayModel from 'garaje/models/workplace-day';

class DeskLocationModel extends Model {
  @belongsTo('location', { async: true, inverse: null }) declare location: AsyncBelongsTo<LocationModel>;
  @belongsTo('company', { async: true, inverse: null }) declare company: AsyncBelongsTo<CompanyModel>;
  @hasMany('workplace-day', { async: true, inverse: 'deskLocation' })
  declare workplaceDays: AsyncHasMany<WorkplaceDayModel>;

  @attr('boolean') declare active: boolean;
  @attr('number') declare desksQuantity: number;
  @attr('number') declare assignableDesksQuantity: number;
  @attr('boolean') declare autoAssignDesk: boolean;
  @attr('boolean') declare deskLendingEnabled: boolean;
  @attr('string') declare checkInRequiredBy: string;
  @attr('number') declare checkInDuration: number;
  @attr('string') declare timeZone: string;
  @attr('number') declare neighborhoodSliderSetting: number;
  @attr('boolean') declare hasSharedDesks: boolean;
}

export default DeskLocationModel;

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'desk-location': DeskLocationModel;
  }
}
